// extracted by css-extract-rspack-plugin
export default {"stepper":"UiStepper_stepper_d42X8"};